import tchat from '@amo/core/assets/images/AMO_Icons/Service-client.svg';
import { Question } from '@amo/core/components/containers';
import {Text} from '@amo/core/components/forms';
import { normalizeTel } from '@amo/core/utils/normalize.js';
import { postLogConsent } from '@amo/core/utils/requestsApi';
import { validatePhone } from '@amo/core/utils/validateField';
import _ from 'lodash';
import { Field } from 'redux-form';
import {getTranslation} from "@amo/core/utils/index.js";
import {RadioBlock} from "@amo/core/components/forms/RadioBlock/RadioBlock.jsx";

const NumeroTel = (props) => {

    const { postFill, data, changeValue, nameWhitelabel, loadingPostFill, token, canal, isComparateur, isAppGPT } = props;

    async function logConsent(token, canal, phone, email, phone_contact_consent) {
        await postLogConsent({token, canal, phone, email, phone_contact_consent, type: 'souscription'});
    }

    const onClickNext = () => {
        postFill(isAppGPT ? {} : { getTarif: true });

        const personne = data?.DemandeTarif?.ListePersonnes?.[0];
        logConsent(
            token,
            canal,
            personne?.TelPortable ?? '',
            personne?.Email ?? '',
            data?.DemandeDevis?.PhoneContactConsent ?? false
        );
    };

    return (
        <Question asFieldset required icon={tchat} title={getTranslation('coordonnees.phone.title')}>
            <div className={'row justify-content-center mt-2'}>
                <div className={'col-md-6 col-12 my-2'}>
                    <Field
                        component={Text}
                        type={'tel'}
                        typeFormat={'tel'}
                        name={'DemandeTarif[ListePersonnes][0][TelPortable]'}
                        required
                        placeholder={getTranslation('example', {value: '02 38 53 02 38'})}
                        validate={validatePhone}
                        onChange={(e) => changeValue('DemandeContrat[SignaturePhone]', normalizeTel(e.target.value))}
                        autocomplete="tel"
                    />
                </div>
            </div>
            {!isComparateur && (
                <div className={'row mt-3'}>
                    <div className={'col-12 col-md-6 offset-md-3 text-start'}>
                        <p><strong>Pourquoi accepter un rappel téléphonique ?</strong></p>
                        <p >Nos conseillers sont là pour vous simplifier la vie :</p>
                        <ul>
                            <li>Un accompagnement personnalisé pour choisir la formule adaptée</li>
                            <li>Des réponses rapides de nos experts à vos questions</li>
                            <li>La garantie d'un suivi transparent et sans engagement</li>
                        </ul>
                        <p className={'mb-4'}><small>Pour vous conseiller au mieux dans le cadre de votre démarche vous pourrez être recontacté par un conseiller mandaté d'APRIL&nbsp;Moto à savoir ADM&nbsp;Value (n°&nbsp;ORIAS&nbsp;10055724). En l'absence d'un contrat en cours d'exécution, toute sollicitation téléphonique effectuée à des fins commerciales suppose votre consentement préalable</small></p>

                        <Field
                            component={RadioBlock}
                            type={'radio'}
                            name={'DemandeDevis[PhoneContactConsent]'}
                            value={'true'}
                            label={getTranslation("iAccept")}
                            className={'mb-2'}
                        />
                        <Field
                            component={RadioBlock}
                            type={'radio'}
                            name={'DemandeDevis[PhoneContactConsent]'}
                            value={'false'}
                            label={getTranslation("iRefuse")}
                        />
                    </div>
                </div>
            )}

            <button
                className={`btn btn-primary btn-arrow mt-4 ${
                    !_.get(data, 'DemandeTarif[ListePersonnes][0][TelPortable]') ||
                    validatePhone(_.get(data, 'DemandeTarif[ListePersonnes][0][TelPortable]')) ||
                    (!isComparateur && !_.get(data, 'DemandeDevis[PhoneContactConsent]'))
                        ? 'disabled'
                        : ''
                }`}
                onClick={() => (loadingPostFill ? null : onClickNext())}
            >
                {loadingPostFill ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                ) : (
                    isAppGPT
                        ? getTranslation('continue')
                        : getTranslation('coordonnees.phone.acceptRecontact.comparePrice')
                )}
            </button>
        </Question>
    );
};

export default NumeroTel;